import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {AnimationOptions} from 'ngx-lottie';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {FlowPageDataProduct, FlowSummary, QuestionFlowCollation} from '../../models/quote.model';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';
import {FlowPlayerService} from '../../services/flow-player.service';
import {QuestionQuery} from '../state/question.query';
import {Router} from '@angular/router';
import {Observable, of, Subscription} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {Alert} from '../../../shared/utilities';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { ComponentsService } from '../../services/components-service';
import { SuperflowStore } from '../state/superflow.store';
import { SidesheetComponent, SidesheetItem } from '../../components/sidesheet/sidesheet.component';
import { RouterLinks } from '../../constants';
import { StorageService } from 'src/app/modules/shared/services/storage.service';

declare var $: any;
declare const Tawk_API: any;

interface CompareItemGroup {
  group_id: number;
  group_name: string;
  totalCells: any[];
  rows: { key: string; title: string; subtitle: string; cells: any[]; more: (string | null)[] }[];
}

interface CompareDetailGroup {
  group_id: number;
  group_name: string;
  rows: { key: string; label: string; description: string | null; img_path: string | null; cells: any[]; otherCells: any[] }[];
}

interface CompareRow {
  key: string;
  entity_id: number;
  label: string;
  img_path: string | null;
  cells: any[];
}

@Component({
    selector: 'app-question-quote',
    templateUrl: './question-quote.component.html',
    styleUrls: ['./question-quote.component.scss'],
    standalone: false
})
export class QuestionQuoteComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild('benefitsSidesheet') benefitsSidesheet: SidesheetComponent;
  @ViewChild('breakdownSidesheet') breakdownSidesheet: SidesheetComponent;
  @ViewChild('ratingSidesheet') ratingSidesheet: SidesheetComponent;
  @ViewChild('excessesSidesheet') excessesSidesheet: SidesheetComponent;

  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() submitResponse = new EventEmitter<any>();
  @Output() showEditModal = new EventEmitter<any>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSummaryDataChanged = new EventEmitter<any>();
  @Output() navigateBack = new EventEmitter<void>();

  collations: QuestionFlowCollation[] = [];
  summaryCollations: QuestionFlowCollation[] = [];
  product: FlowPageDataProduct;
  summary = new FlowSummary();
  sessionDetails: any;
  selectedItem: any;
  classes: QuestionFlowCollation[] = [];
  classItems: any[] = [];
  isSavingData = false;
  parameter: any;
  summaryDataSubscription: Subscription;
  recommendation: any;
  user: any;
  window: any['dataLayer'] = window['dataLayer'] || [];
  selectedRecommendation: any
  quotePageData: any;
  /** Set when the payload is a notice (e.g. quote already converted) rather than page data; the template shows it in place of the page. */
  index0: any;
  products: any[];
  tiers: any[];
  benefitsData: SidesheetItem[] = [];
  breakdownData: SidesheetItem[] = [];
  breakdownTotal: string = '0';
  selectedTierForRating: any = null;
  selectedTierForExcesses: any = null;
  lottieOptions: AnimationOptions = {
    path: 'assets/evi-icon.json',
  };
  /**
   * The product the user has committed to, as opposed to `selectedProduct`, which the
   * sidesheet handlers reuse for whichever card is currently being inspected. Seeded
   * from the payload's selected=1 and only changed by an explicit choice.
   */
  chosenProductId: number | null = null;
  // set from Continue in the Important things to know modal until the page advances; drives the button spinner
  choosingProductId: number | null = null;
  selectedProduct: any;
  selectedProducts: any[];
  originalSelectedProducts: any[];
  filterTouched: boolean = false;
  selectedTier: any;
  pageInfo: any;
  /** Header tooltip text by section ('features' | 'included' | 'not_included'); a missing key means no icon. */
  sectionTooltips: Record<string, string> = {};
  quote: any;
  numPlans: number = 3;
  quoteITKs: any = {};
  excessesData: any[] = [];
  /** What's Covered / Not Covered modal: the card being viewed (kept apart from selectedProduct), its rows, and rows already fetched. */
  coversProduct: any = null;
  coversData: any[] = [];
  coversLoading = false;
  coversTab: 'covered' | 'not_covered' = 'covered';
  coversActiveClass: number | null = null;
  private coversCache = new Map<number, any[]>();
  chat: any;
  addedBenefits: any[];
  frequencyId: number = 3;
  isSliderReady = false;

  /** Compare tray: how many products can be compared at once, and the ones ticked so far (by product_id, so a slider rebuild or tier change keeps them). */
  readonly maxCompare = 2;
  compareIds: number[] = [];
  /** Compare modal: every product's rows load once on first open; the selected products' columns are then built from them. */
  compareLoading = false;
  compareError = false;
  private compareRows: any[] | null = null;
  /** One row per feature / included VAP across the compared products, in first-seen order; `cells[i]` is the row for column i, or null when that product lacks it. */
  compareFeatureRows: CompareRow[] = [];
  compareIncludedRows: CompareRow[] = [];
  compareNotIncludedRows: CompareRow[] = [];
  /** In more detail: which compared product's column shows on a narrow screen (the toggler switches it), and the insurer rating rows aligned across the products. */
  compareDetailActive = 0;
  compareInsurerRatingRows: { rating_type: string; cells: any[] }[] = [];
  /** In more detail data, loaded the first time a subsection opens for the compared products only, and kept per product. */
  comparePdfLoading = false;
  compareDetailLoading = false;
  compareDetailError = false;
  private compareDetailRequested = false;
  private compareDetailCache = new Map<number, any[]>();
  compareCoveredGroups: CompareDetailGroup[] = [];
  compareNotCoveredGroups: CompareDetailGroup[] = [];
  compareBenefitGroups: CompareDetailGroup[] = [];
  compareItemGroups: CompareItemGroup[] = [];
  /** Per column, whether the See more collapse (mobile only) is open; drives the trigger's text. */
  compareMoreOpen: boolean[] = [];

  /** Per-card refresh state after an excess change; a missing entry means idle. */
  cardState = new Map<number, 'refreshing' | 'error'>();
  /** Wording + underwriting run once after the excess sheet closes; Choose waits on it. */
  checksState: 'idle' | 'running' | 'error' = 'idle';
  /** Cards whose premium is behind the session's excess answers and not yet refreshed. */
  private staleProductIds = new Set<number>();
  private excessDirty = false;
  // A newer request for the same card / the checks supersedes an older in-flight one.
  private cardTokens = new Map<number, number>();
  private checksToken = 0;
  constructor(
    public questionService: GlobalQuestionService,
    private flowPlayer: FlowPlayerService,
    private ref: ChangeDetectorRef,
    private router: Router,
    private userStore: UserStore,
    private QuestionQuery: QuestionQuery,
    private superflowStore: SuperflowStore,
    private componentsService: ComponentsService,
    private storageService: StorageService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery) {
    this.sessionDetails = this.questionFlowSessionQuery.getValue(); 
    console.log(this.sessionDetails);
  }


  ngOnInit(): void {
    this.chat = Tawk_API;
    this.user = this.userStore.getValue();
    //this.Sidesheet = Sidesheet;
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }
    const rawData = this.storageService.get('quotePageData', 'flow');
    if (rawData) {
      const allData: any[][] = JSON.parse(rawData);
      this.populateQuotePageData(allData);
    } else {
      // No loader run in this tab/session (e.g. direct question_id entry, resume link
      // in a new tab) - fetch instead of rendering empty.
      this.questionService.getQuotePageData('quote', this.sessionDetails.session_id, this.sessionDetails.category_id, this.sessionDetails.group_id, this.user?.person_id ? this.user.person_id : '0')
        .subscribe((result: any) => {
          if (result && result.length > 0) {
            this.storageService.setJson('quotePageData', result, 'flow');
            this.populateQuotePageData(result);
          }
        });
    }
  }

  /**
   * Lays the page out from a getQuotePageData payload.
   *
   * `targetProductId` pins the product to land on. When it is omitted the payload's
   * own selected=1 product is used, which getQuotePageData derives from the session's
   * product_selected row - i.e. what the user actually chose. recommended=1 is only
   * the configured default and is the fallback, for payloads predating the selected
   * flag and for sessions where nothing has been chosen yet.
   */
  private populateQuotePageData(allData: any[][], targetProductId?: number, targetTierId?: number): void {
    // Same check as quote-pick-cover: a session that is already a policy comes back as a notice instead of
    // page data. It is not left cached, so the next visit asks again rather than replaying it.
    this.index0 = this.questionService.getIndex0(allData);
    if (this.index0) {
      this.storageService.remove('quotePageData', 'flow');
      return;
    }
    this.quotePageData = allData[1];
    this.cardState.clear();
    this.staleProductIds.clear();
    this.excessDirty = false;
    this.checksToken++;
    this.checksState = 'idle';

    this.pageInfo = this.quotePageData.find((item: any) => item.entry_type === 'page_info');
    this.sectionTooltips = {};
    try {
      for (const row of (this.pageInfo?.section_tooltips ? JSON.parse(this.pageInfo.section_tooltips) : [])) {
        if (row?.section && row?.tooltip) {
          this.sectionTooltips[row.section] = row.tooltip;
        }
      }
    } catch {
      this.sectionTooltips = {};
    }
    this.tiers = this.quotePageData.filter((item: any) => item.entry_type === 'product_tier');
    this.quote = this.quotePageData.find((item: any) => item.entry_type === 'overview');
    const recommendedProduct = this.quotePageData.find((item: any) => item.entry_type === 'product' && item.recommended === 1)
      ?? this.quotePageData.find((item: any) => item.entry_type === 'product' && item.frequency_id != null);
    this.frequencyId = recommendedProduct?.frequency_id ?? 3;

    const chosenProduct = targetProductId != null
      ? this.quotePageData.find((item: any) => item.entry_type === 'product' && item.product_id === targetProductId)
      : this.quotePageData.find((item: any) => item.entry_type === 'product' && item.selected === 1);

    // The tier matters as much as the product: products are filtered to the selected
    // tier, so landing on the wrong one drops the chosen product off the page entirely.
    const tierId = targetTierId ?? chosenProduct?.tier_id;
    this.selectedTier = (tierId != null ? this.tiers.find((tier: any) => tier.tier_id === tierId) : null)
      ?? this.tiers.find((tier: any) => tier.recommended === 1)
      ?? this.tiers[0];

    this.chosenProductId = chosenProduct?.product_id ?? null;

    const slideIndex = this.buildProductsForTier(chosenProduct?.product_id);
    this.renderSlider(slideIndex);
  }

  /**
   * Whether this is the product the user committed to. Drives the call to action only -
   * the orange border, the tier dot and the "Recommended" badge stay with
   * recommended=1, which is a claim about the product rather than about this session.
   */
  isChosen(product: any): boolean {
    return this.chosenProductId != null && product?.product_id === this.chosenProductId;
  }

  /** The "Not finding anything in <tier> that works for you?" line split around the tier name so the name can be strong; the wording stays the DB's. */
  get tierRefine(): { before: string; name: string; after: string } | null {
    const text: string = this.selectedTier?.tier_refine_options;
    if ((this.tiers?.length ?? 0) <= 1 || !text) return null;
    const name: string = this.selectedTier?.tier_name;
    const at = name ? text.indexOf(name) : -1;
    return at < 0
      ? { before: text, name: '', after: '' }
      : { before: text.slice(0, at), name, after: text.slice(at + name.length) };
  }

  isCompared(product: any): boolean {
    return this.compareIds.includes(product?.product_id);
  }

  /** A full tray only blocks cards that are not already in it, so a ticked card can always be unticked. */
  compareDisabled(product: any): boolean {
    return !this.isCompared(product) && this.compareIds.length >= this.maxCompare;
  }

  toggleCompare(product: any): void {
    const id = product?.product_id;
    if (id == null) return;
    if (this.isCompared(product)) {
      this.compareIds = this.compareIds.filter(existing => existing !== id);
    } else if (this.compareIds.length < this.maxCompare) {
      this.compareIds = [...this.compareIds, id];
    }
  }

  removeCompare(productId: number): void {
    this.compareIds = this.compareIds.filter(existing => existing !== productId);
  }

  /** Asks the pdf-service to render the printable Compare page (route everything.quote-compare-pdf) for the two compared products and shows it in the shared PDF preview. */
  downloadComparePdf(event: Event): void {
    event.preventDefault();
    if (this.comparePdfLoading || this.compareIds.length < this.maxCompare) return;
    this.comparePdfLoading = true;
    this.questionService.spinner(true);
    this.questionService.downloadPDF(RouterLinks.QuoteComparePdf, {
      sessionId: this.sessionDetails?.session_id,
      extraParams: { product_group_id: String(this.sessionDetails?.group_id), product_ids: this.compareIds.join(',') }
    }).subscribe({
      next: (blob: Blob) => {
        this.questionService.spinner(false);
        this.comparePdfLoading = false;
        this.questionService.showPDFPreview(URL.createObjectURL(new Blob([blob], { type: 'application/pdf' })));
      },
      error: () => {
        this.questionService.spinner(false);
        this.comparePdfLoading = false;
        Alert('PDF generation failed. Please try again.', 5000);
      }
    });
  }

  openCompareModal(event: Event): void {
    event.preventDefault();
    if (this.compareIds.length < this.maxCompare) return;
    this.buildCompare();
    if (!this.compareRows) this.loadCompare();
    $('#modal-compare').modal('show');
  }

  loadCompare(event?: Event): void {
    event?.preventDefault();
    this.compareLoading = true;
    this.compareError = false;
    this.compareMoreOpen = [];
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails?.session_id);
    parameters.set('product_group_id', String(this.sessionDetails?.group_id));
    this.questionService.runCommandNew('getQuoteCompare', parameters).subscribe({
      next: (rows: any[]) => {
        this.compareRows = rows ?? [];
        this.compareLoading = false;
        this.buildCompare();
      },
      error: () => {
        this.compareLoading = false;
        this.compareError = true;
      }
    });
  }

  /** Swaps the product in one column; the tray follows because both read compareIds. */
  selectCompareProduct(slot: number, productId: number, event: Event): void {
    event.preventDefault();
    const ids = [...this.compareIds];
    ids[slot] = productId;
    this.compareIds = ids;
    this.buildCompare();
    if (this.compareDetailRequested) this.ensureCompareDetail();
  }

  /** Products a column's dropdown offers: the page's cards, minus the product shown in the other column. */
  compareCandidates(slot: number): any[] {
    const others = this.compareIds.filter((_, index) => index !== slot);
    return (this.products ?? []).filter((p: any) => !others.includes(p.product_id));
  }

  private buildCompare(): void {
    this.compareFeatureRows = this.alignCompareRows('feature');
    this.compareIncludedRows = this.alignCompareRows('included');
    this.compareNotIncludedRows = this.alignCompareRows('not_included');
    this.buildInsurerRatingRows();
    setTimeout(() => this.questionService.initPopoverCustomize(), 100);
  }

  /** Subsections that only exist for products that have the data, so a section never opens onto nothing. */
  get compareHasCovers(): boolean {
    return this.compareSlots.some(product => !!product?.has_covers);
  }

  /** Loads the In more detail rows for any compared product not fetched yet, then lays the subsections out. */
  ensureCompareDetail(event?: Event): void {
    event?.preventDefault?.();
    this.compareDetailRequested = true;
    const missing = this.compareIds.filter(id => !this.compareDetailCache.has(id));
    if (!missing.length) {
      this.buildCompareDetail();
      return;
    }
    this.compareDetailLoading = true;
    this.compareDetailError = false;
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails?.session_id);
    parameters.set('product_ids', missing.join(','));
    this.questionService.runCommandNew('getQuoteCompareDetail', parameters).subscribe({
      next: (rows: any[]) => {
        missing.forEach(id => this.compareDetailCache.set(id, (rows ?? []).filter(row => row.product_id === id)));
        this.compareDetailLoading = false;
        this.buildCompareDetail();
      },
      error: () => {
        this.compareDetailLoading = false;
        this.compareDetailError = true;
      }
    });
  }

  private buildCompareDetail(): void {
    this.compareCoveredGroups = this.alignDetailGroups('covered');
    this.compareNotCoveredGroups = this.alignDetailGroups('not_covered');
    this.compareBenefitGroups = this.alignDetailGroups('benefit');
    this.compareItemGroups = this.alignItemGroups();
  }

  /** Your Insured Items: a class header with each product's class total, then the items, matched across products by item. */
  private alignItemGroups(): CompareItemGroup[] {
    const columns = this.compareSlots;
    const rowsOf = (product: any) => this.compareDetailCache.get(product?.product_id) ?? [];
    const groups = new Map<number, { group_name: string; order: string[]; label: Map<string, string> }>();
    for (const product of columns) {
      for (const row of rowsOf(product)) {
        if (row.entry_type !== 'item') continue;
        const group = groups.get(row.group_id) ?? { group_name: row.group_name, order: [], label: new Map<string, string>() };
        if (!group.label.has(row.entity_key)) {
          group.label.set(row.entity_key, row.label ?? '');
          group.order.push(row.entity_key);
        }
        groups.set(row.group_id, group);
      }
    }
    return [...groups.entries()]
      .sort(([a], [b]) => a - b)
      .map(([group_id, group]) => ({
        group_id,
        group_name: group.group_name,
        totalCells: columns.map(product => rowsOf(product).find(r => r.entry_type === 'class_total' && r.group_id === group_id) ?? null),
        rows: group.order.map(key => {
          const cells = columns.map(product => rowsOf(product).find(r => r.entry_type === 'item' && r.group_id === group_id && r.entity_key === key) ?? null);
          const parts = (group.label.get(key) ?? '').split('|');
          return { key, title: parts[0] ?? '', subtitle: parts[1] ?? '', cells, more: this.moreLabels(cells) };
        })
      }));
  }

  /** For an item priced differently across the products, the dearer one's "R 20 /mo more" tag; the cheaper one has none. */
  private moreLabels(cells: any[]): (string | null)[] {
    const amounts = cells.filter(cell => cell?.amount != null).map(cell => cell.amount as number);
    if (amounts.length < 2) return cells.map(() => null);
    const lowest = Math.min(...amounts);
    const frequency = this.compareSlots.find(product => product)?.frequency_short ?? '';
    return cells.map(cell => cell?.amount != null && cell.amount > lowest
      ? `R ${Math.round(cell.amount - lowest).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} /${frequency} more`
      : null);
  }

  /** Lines a detail subsection up across the compared columns: groups by class, rows by statement within a class. */
  private alignDetailGroups(entryType: string): CompareDetailGroup[] {
    const columns = this.compareSlots;
    const keyOf = (row: any) => `${row.group_id}|${row.entity_key}`;
    const byProduct = columns.map(product => {
      const lookup = new Map<string, any>();
      for (const row of this.compareDetailCache.get(product?.product_id) ?? []) {
        if (row.entry_type === entryType && !lookup.has(keyOf(row))) lookup.set(keyOf(row), row);
      }
      return lookup;
    });
    // The opposite list, so a gap can say whether the product covers the statement (a not-covered row it is not in) or not.
    const otherType = entryType === 'covered' ? 'not_covered' : entryType === 'not_covered' ? 'covered' : null;
    const otherByProduct = columns.map(product => {
      const lookup = new Map<string, any>();
      for (const row of otherType ? this.compareDetailCache.get(product?.product_id) ?? [] : []) {
        if (row.entry_type === otherType && !lookup.has(keyOf(row))) lookup.set(keyOf(row), row);
      }
      return lookup;
    });
    const groups = new Map<number, { group_name: string; order: string[]; first: Map<string, any> }>();
    for (const lookup of byProduct) {
      lookup.forEach((row, key) => {
        const group = groups.get(row.group_id) ?? { group_name: row.group_name, order: [], first: new Map<string, any>() };
        if (!group.first.has(key)) {
          group.first.set(key, row);
          group.order.push(key);
        }
        groups.set(row.group_id, group);
      });
    }
    return [...groups.entries()]
      .sort(([a], [b]) => a - b)
      .map(([group_id, group]) => ({
        group_id,
        group_name: group.group_name,
        rows: group.order.map(key => ({
          key,
          label: group.first.get(key).label,
          description: group.first.get(key).description ?? null,
          img_path: group.first.get(key).img_path ?? null,
          cells: byProduct.map(lookup => lookup.get(key) ?? null),
          otherCells: otherByProduct.map(lookup => lookup.get(key) ?? null)
        }))
      }));
  }

  private buildInsurerRatingRows(): void {
    const columns = this.compareSlots;
    const types: string[] = [];
    for (const product of columns) {
      for (const rating of product?.insurer_rating ?? []) {
        if (!types.includes(rating.rating_type)) types.push(rating.rating_type);
      }
    }
    this.compareInsurerRatingRows = types.map(rating_type => ({
      rating_type,
      cells: columns.map(product => product?.insurer_rating?.find((r: any) => r.rating_type === rating_type) ?? null)
    }));
  }

  /** The overall rating as the percent-per-star list the star markup takes, e.g. ['100','100','75','0','0']. */
  starPercents(product: any): string[] {
    return (product?.insurer_rating?.[0]?.overall_rating ?? '').split('|').filter((p: string) => p !== '');
  }

  /** Closes the modal before leaving for the wording page, so its backdrop does not linger over the next page. */
  viewCompareWording(product: any, event: Event): void {
    event.preventDefault();
    $('#modal-compare').one('hidden.bs.modal', () => this.viewPolicyWording(product));
    $('#modal-compare').modal('hide');
  }

  /** Lines one section's rows up across the compared columns, matching rows by entity type and id (a VAP and a feature can share an id). */
  private alignCompareRows(entryType: string): CompareRow[] {
    const keyOf = (row: any) => `${row.entity_type ?? ''}:${row.entity_id}`;
    const rows = (this.compareRows ?? []).filter(row => row.entry_type === entryType);
    const columns = this.compareSlots;
    const order: string[] = [];
    const first = new Map<string, any>();
    for (const product of columns) {
      if (!product) continue;
      for (const row of rows.filter(r => r.product_id === product.product_id)) {
        if (!first.has(keyOf(row))) {
          first.set(keyOf(row), row);
          order.push(keyOf(row));
        }
      }
    }
    return order.map(key => {
      const cells = columns.map(product => product
        ? rows.find(r => r.product_id === product.product_id && keyOf(r) === key) ?? null
        : null);
      const head = first.get(key);
      return { key, entity_id: head.entity_id, label: head.label, img_path: cells.find(cell => cell)?.img_path ?? null, cells };
    });
  }

  /** One entry per tray slot: the product being compared, or null for an empty slot. Looked up live so a refreshed price shows. */
  get compareSlots(): any[] {
    return Array.from({ length: this.maxCompare }, (_, slot) => {
      const id = this.compareIds[slot];
      if (id == null) return null;
      return this.products?.find((p: any) => p.product_id === id)
        ?? this.quotePageData?.find((p: any) => p.entry_type === 'product' && p.product_id === id)
        ?? null;
    });
  }

  /**
   * Builds `products` for the current `selectedTier` and windows them into the three
   * visible cards. `targetProductId`, when supplied and present in the tier, is kept
   * inside that window even if it sorts past the third card, and becomes
   * `selectedProduct`. Returns its index within `selectedProducts`, or -1.
   */
  private buildProductsForTier(targetProductId?: number): number {
    this.products = this.quotePageData
      .filter((item: any) => item.entry_type === 'product' && item.tier_id === this.selectedTier?.tier_id)
      .map((item: any) => ({
        ...item,
        insurer_rating: item.insurer_rating ? JSON.parse(item.insurer_rating) : null,
        benefits: item.benefits ? JSON.parse(item.benefits) : null,
        not_included: item.not_included ? JSON.parse(item.not_included) : null,
        features: item.features ? JSON.parse(item.features) : null
      }));

    const indexInAll = targetProductId != null
      ? this.products.findIndex((p: any) => p.product_id === targetProductId)
      : -1;

    if (this.products.length <= 3) {
      this.selectedProducts = [...this.products];
      this.numPlans = this.products.length;
    } else if (indexInAll >= 3) {
      // Slide the window so the target stays on screen. Clamped to the end of the list
      // so the window always holds three cards - numPlans says 3 either way.
      const startIndex = Math.min(indexInAll - 1, this.products.length - 3);
      this.selectedProducts = this.products.slice(startIndex, startIndex + 3);
      this.numPlans = 3;
    } else {
      this.selectedProducts = this.products.slice(0, 3);
      this.numPlans = 3;
    }
    this.originalSelectedProducts = [...this.selectedProducts];

    if (indexInAll >= 0) {
      this.selectedProduct = this.products[indexInAll];
    }

    return targetProductId != null
      ? this.selectedProducts.findIndex((p: any) => p.product_id === targetProductId)
      : -1;
  }

  /** Rebuilds the slick slider, optionally landing on a given slide. */
  private renderSlider(slideIndex: number = -1): void {
    this.destroySlider();
    setTimeout(() => {
      this.initSliders(this.numPlans, slideIndex);
      // Initialize Bootstrap popovers after slider content is rendered
      this.questionService.initPopoverCustomize();
      this.refreshVisibleStale();
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;

    }
  }
  ngAfterViewInit(): void {
    document.querySelector('body')?.classList.add('page--questions');
    document.querySelector('body')?.classList.add('page--questions-no-tray');
    document.querySelector('body')?.classList.add('page--questions-top-aligned');
  }
  initSliders(numPlans: number, slideIndex: number = -1): void {
    const $chooseSlider = $('#choose-slider');

    const chooseSliderSettings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      prevArrow: '<button type="button" class="slick-prev"><svg class="icon icon--lg"><use xlink:href="#chevron-right"></use></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg class="icon icon--lg"><use xlink:href="#chevron-right"></use></svg></button>',
      infinite: false,
      speed: 300,
      swipeToSlide: true,
      mobileFirst: true,
      rows: 0,
      responsive: [{
        breakpoint: 992,
        settings: {
          arrows: numPlans > 3
        }
      }]
    };

    // Initialize slick slider
    $chooseSlider.slick(chooseSliderSettings);

    // Handle 2 slides layout
    if (numPlans === 2) {
      $chooseSlider.addClass('choose-slider--2');
    } else {
      $chooseSlider.removeClass('choose-slider--2');
    }

    // Navigate to appropriate slide. One slickGoTo only: a second call landed while the
    // first was still animating and was dropped, which is why restoring the chosen
    // product left the slider on the default middle card.
    //
    // Under three cards the track stays at 0 even when the chosen product is not the
    // first. Every card is on screen at that size, so there is nothing to scroll to,
    // and .choose-slider--2 re-centres the pair with a CSS translate that assumes the
    // track has not moved - shifting it as well double-shifts the row off centre.
    const target = numPlans < 3
      ? 0
      : (slideIndex >= 0 ? slideIndex : 1);
    $chooseSlider.slick('slickGoTo', target, false);

    // Animate in the slides
    const planSlides = document.querySelectorAll('.choose-slider__slide');
    planSlides.forEach((slide) => {
      slide.addEventListener('animationend', () => {
        slide.classList.remove('animating-in');
      }, { once: true });
      slide.classList.add('animating-in');
    });

    this.isSliderReady = $chooseSlider.length > 0;
    this.questionService.initPopoverCustomize();
  }

  openBenefitsSidesheet(product: any, event: Event): void {
    event.preventDefault();
    this.selectedProduct = product;
     const parameters = new Map<string, string>();
      parameters.set('session_id', this.sessionDetails?.session_id);
      parameters.set('category_id', this.sessionDetails?.category_id);
      parameters.set('product_id', product.product_id);
      parameters.set('frequency_id', this.frequencyId.toString());
      this.questionService.runCommandNew('getAddedBenefits', parameters).subscribe({
        next: (benefits: any[]) => {
          console.log(benefits);
          this.questionService.spinner(false);
          this.addedBenefits = benefits;
        },
        error: () => {
          this.questionService.spinner(false);
        }
      });
    // Transform tier benefits into SidesheetItem format
    // if (product?.benefits) {
    //   this.benefitsData = product.benefits.map((benefit: any) => ({
    //     icon: benefit.img_path || 'assets/icn/class/sm-vehicle.svg',
    //     title: benefit.vaps_name,
    //     price: benefit.limit ? `${benefit.limit}` : null,
    //     priceLabel: '/mo'
    //   }));
    // }
    if (this.benefitsSidesheet) {
      this.benefitsSidesheet.open(event);
      document.body.classList.add('sidesheet-open');
    }
  }

  onBenefitsSidesheetClosed(): void {
    // Optional: handle sidesheet close event
  }

  onBenefitItemSelected(item: SidesheetItem): void {
    // Optional: handle item selection
    console.log('Benefit item selected:', item);
  }

  openBreakdownSidesheet(product: any, event: Event): void {
    event.preventDefault();
    this.selectedProduct = product;

    // Transform tier data into breakdown items
    if (product) {
      this.breakdownData = [];
      //this.questionService.spinner(true);
      const parameters = new Map<string, string>();
      parameters.set('session_id', this.sessionDetails?.session_id);
      parameters.set('category_id', this.sessionDetails?.category_id);
      parameters.set('product_id', product.product_id);
      parameters.set('frequency_id', this.frequencyId.toString());
      this.questionService.runCommandNew('getInsuredItems', parameters).subscribe({
        next: (items: any[]) => {
          this.questionService.spinner(false);
          this.breakdownData = items;
        },
        error: () => {
          this.questionService.spinner(false);
        }
      });
      // Add base premium


      // Add benefits breakdown
      if (product.benefits) {
        product.benefits.forEach((benefit: any) => {
          if (benefit.premium) {
            this.breakdownData.push({
              icon: benefit.img_path,
              title: benefit.vaps_name,
              price: benefit.premium
            });
          }
        });
      }

      // Set total
      this.breakdownTotal = product.premium || '0';
    }
    if (this.breakdownSidesheet) {
      this.breakdownSidesheet.open(event);
      document.body.classList.add('sidesheet-open');
    }
  }

  onBreakdownSidesheetClosed(): void {
    // Optional: handle sidesheet close event
  }

  openRatingSidesheet(product: any, event: Event): void {
    event.preventDefault();
    this.selectedProduct = product;
    if (this.ratingSidesheet) {
      this.ratingSidesheet.open(event);
      document.body.classList.add('sidesheet-open');
    }
  }

  onRatingSidesheetClosed(): void {
    // Deliberately does not clear selectedProduct: it now carries the restored
    // selection, not just whichever card opened this sidesheet. The sidesheet's own
    // state is selectedTierForRating.
    this.selectedTierForRating = null;
  }

  openExcessesSidesheet(product: any, event: Event): void {
    event.preventDefault();
    this.selectedProduct = product;
    this.excessesData = [];
    //this.questionService.spinner(true);
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails?.session_id);
    parameters.set('product_id', product.product_id);
    parameters.set('frequency_id', this.frequencyId.toString());
    this.questionService.runCommandNew('getExcesses', parameters).subscribe({
      next: (excesses: any[]) => {
        this.questionService.spinner(false);
        this.excessesData = excesses;
      },
      error: () => {
        this.questionService.spinner(false);
      }
    });
    if (this.excessesSidesheet) {
      this.excessesSidesheet.open(event);
      document.body.classList.add('sidesheet-open');
    }
  }

  /** Opens the What's Covered / Not Covered modal for one card, loading its statements the first time and keeping them for the page. */
  openCoversModal(product: any, event: Event): void {
    event.preventDefault();
    this.coversProduct = product;
    this.coversTab = 'covered';

    const cached = this.coversCache.get(product.product_id);
    this.coversLoading = !cached;
    this.coversData = cached ?? [];
    this.coversActiveClass = this.coverClasses[0]?.class_id ?? null;

    if (!cached) {
      const parameters = new Map<string, string>();
      parameters.set('session_id', this.sessionDetails?.session_id);
      parameters.set('product_id', product.product_id);
      this.questionService.runCommandNew('getQuoteCovers', parameters).subscribe({
        next: (covers: any[]) => {
          this.coversCache.set(product.product_id, covers ?? []);
          if (this.coversProduct?.product_id === product.product_id) {
            this.coversData = covers ?? [];
            this.coversActiveClass = this.coverClasses[0]?.class_id ?? null;
            this.coversLoading = false;
          }
        },
        error: () => {
          if (this.coversProduct?.product_id === product.product_id) {
            this.coversLoading = false;
          }
        }
      });
    }

    $('#covered-modal').modal('show');
  }

  get coverClasses(): any[] {
    return (this.coversData ?? []).filter(row => row.entry_type === 'class');
  }

  /** An optional extension is not covered unless the customer adds it, so it lists with the exclusions. */
  coversFor(classId: number): any[] {
    return (this.coversData ?? []).filter(row =>
      row.entry_type === 'cover'
      && row.class_id === classId
      && (this.coversTab === 'covered' ? row.status === 'covered' : row.status !== 'covered'));
  }

  setCoversTab(tab: 'covered' | 'not_covered', event: Event): void {
    event.preventDefault();
    if (this.coversTab === tab) {
      return;
    }
    this.coversTab = tab;
    // Both tabs share one scroll area, so land on the class the customer was reading
    setTimeout(() => this.scrollToCoversClass(this.coversActiveClass));
  }

  scrollToCoversClass(classId: number | null, event?: Event): void {
    event?.preventDefault();
    if (classId == null) {
      return;
    }
    this.coversActiveClass = classId;
    const $content = $('#covered-content');
    const $target = $('#covered-section-' + classId);
    if (!$content.length || !$target.length) {
      return;
    }
    $content.stop().animate({
      scrollTop: $target.position().top + $content.scrollTop() - $('#covered-header').outerHeight() - 20
    }, 400);
  }

  /** Slider cards reserve one row per link, so a card without the covers link does not sit a row higher than the rest. */
  get maxActionLinks(): number {
    const cards = this.selectedProducts ?? [];
    return 1
      + (cards.some(product => !!product?.has_covers) ? 1 : 0)
      + (cards.some(product => !!product?.has_wording) ? 1 : 0);
  }

  onExcessesSidesheetClosed(): void {
    this.selectedTierForExcesses = null;
    this.excessesData = [];
    if (!this.excessDirty) {
      return;
    }
    this.excessDirty = false;

    // The excess answer is shared by every product in the group, so every other card is now
    // behind it. Refresh the ones on screen straight away and the rest when they come into view.
    const focusId = this.selectedProduct?.product_id;
    this.products?.forEach(p => {
      if (p.product_id !== focusId) {
        this.staleProductIds.add(p.product_id);
      }
    });

    // Choosing stays disabled from here. The checks run once the visible cards are current: underwriting
    // reads the calc rows, so running it alongside the recalculation could read rows mid-rewrite, and both
    // would queue on the same per-session lock (the checks could push a card refresh past its wait).
    const visibleStale = (this.selectedProducts ?? [])
      .map(p => p.product_id)
      .filter(id => this.staleProductIds.has(id) && this.cardState.get(id) !== 'refreshing');
    this.checksToken++;
    this.checksState = 'running';
    this.refreshCards(visibleStale).subscribe({ complete: () => this.runChecks() });
  }

  /**
   * Saves the new excess and recalculates only the product whose sheet is open, so the sheet
   * and that card update in about a second. Wording, underwriting and the other cards wait for
   * the sheet to close (onExcessesSidesheetClosed).
   */
  onExcessValueChanged(event: { item: any; newValue: number; clearLoading: () => void }): void {
    const question = new Question();
    question.cent_aq_question_id = event.item.question_id;
    question.cent_aq_question_type_id = event.item.question_type_id;
    question.product_class_id = event.item.class_id;
    question.item_id = event.item.item_id?.toString();
    question.answer = event.newValue?.toString();

    const currentProductId = this.selectedProduct?.product_id;

    this.questionService.saveAnswerOnly(question).subscribe({
      next: () => {
        this.excessDirty = true;
        // Choosing must wait for the checks to be rerun against the new excess.
        this.checksToken++;
        this.checksState = 'running';
        this.refreshCards([currentProductId]).subscribe({
          next: () => this.refreshExcessesSidesheet(currentProductId, event.clearLoading),
          error: () => event.clearLoading()
        });
      },
      error: (error: any) => {
        console.error('Error updating excess:', error);
        event.clearLoading();
      }
    });
  }

  /** Refreshes the given cards in one call: the server recalculates them one after another under the per-session lock, so separate calls would only queue there. */
  private refreshCards(productIds: number[]): Observable<void> {
    const ids = productIds.filter(id => id != null);
    return ids.length ? this.fetchCards(ids) : of(void 0);
  }

  private fetchCards(productIds: number[]): Observable<void> {
    const tokens = new Map<number, number>();
    productIds.forEach(id => {
      const token = (this.cardTokens.get(id) ?? 0) + 1;
      this.cardTokens.set(id, token);
      tokens.set(id, token);
      this.cardState.set(id, 'refreshing');
    });
    const isCurrent = (id: number) => this.cardTokens.get(id) === tokens.get(id);

    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails.session_id);
    parameters.set('category_id', String(this.sessionDetails.category_id));
    parameters.set('product_group_id', String(this.sessionDetails.group_id));
    parameters.set('product_ids', productIds.join(','));
    parameters.set('recalc', '1');

    return this.questionService.runCommandNew('getQuoteProductData', parameters).pipe(
      tap((rows: any[]) => {
        productIds.filter(isCurrent).forEach(id => {
          const row = rows?.find(r => r.product_id === id);
          if (row?.status === 'ok') {
            this.patchCard(row);
            this.cardState.delete(id);
            this.staleProductIds.delete(id);
          } else {
            this.cardState.set(id, 'error');
          }
        });
      }),
      catchError((err: any) => {
        console.error('getQuoteProductData Error:', err);
        productIds.filter(isCurrent).forEach(id => this.cardState.set(id, 'error'));
        return of(void 0);
      }),
      map(() => void 0)
    );
  }

  /** Applies a change to the payload, the derived card lists and the cached copy a resumed tab would read. */
  private applyToCards(productId: number, change: (p: any) => void): void {
    const apply = (p: any) => {
      if (p?.product_id === productId) {
        change(p);
      }
    };
    this.quotePageData?.forEach(apply);
    this.products?.forEach(apply);
    this.selectedProducts?.forEach(apply);
    // selectedProduct is normally one of the card objects above; the check keeps a detached copy in step too.
    apply(this.selectedProduct);

    const cached = this.storageService.get('quotePageData', 'flow');
    if (cached) {
      try {
        const all = JSON.parse(cached);
        all[1]?.forEach(apply);
        this.storageService.setJson('quotePageData', all, 'flow');
      } catch { }
    }
  }

  private patchCard(row: any): void {
    this.applyToCards(row.product_id, p => {
      p.premium = row.premium;
      p.addons_premium = row.addons_premium;
    });
  }

  /**
   * Refreshes each card's referral JSON after an excess change. The server skips wording (no rule reads an excess
   * answer) and reruns underwriting only while an excess-linked referral is showing; a retry forces the full rerun.
   */
  private runChecks(full = false): void {
    const token = ++this.checksToken;
    this.checksState = 'running';

    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails.session_id);
    parameters.set('category_id', String(this.sessionDetails.category_id));
    parameters.set('product_group_id', String(this.sessionDetails.group_id));
    parameters.set('excess_change', full ? '0' : '1');

    this.questionService.runCommandNew('runQuoteChecks', parameters).subscribe({
      next: (rows: any[]) => {
        if (token !== this.checksToken) {
          return;
        }
        rows?.forEach(r => this.applyToCards(r.product_id, p => { p.uw_collation = r.uw_collation; }));
        this.checksState = 'idle';
      },
      error: (err: any) => {
        console.error('runQuoteChecks Error:', err);
        if (token === this.checksToken) {
          this.checksState = 'error';
        }
      }
    });
  }

  retryChecks(): void {
    this.runChecks(true);
  }

  retryCard(productId: number): void {
    this.fetchCards([productId]).subscribe();
  }

  /** Refreshes any card that is on screen and behind the session's excess answers. */
  private refreshVisibleStale(): void {
    const ids = (this.selectedProducts ?? [])
      .map(p => p.product_id)
      .filter(id => this.staleProductIds.has(id) && this.cardState.get(id) !== 'refreshing');
    if (ids.length) {
      this.refreshCards(ids).subscribe();
    }
  }

  isPriceRefreshing(product: any): boolean {
    const id = product?.product_id;
    const state = this.cardState.get(id);
    // A card that failed to refresh is still stale, but it must show its error and Retry, not a skeleton.
    return state === 'refreshing' || (state !== 'error' && this.staleProductIds.has(id));
  }

  hasCardError(product: any): boolean {
    return this.cardState.get(product?.product_id) === 'error';
  }

  /** A card can only be chosen once its price is current and the underwriting checks have finished. */
  canChoose(product: any): boolean {
    return this.checksState === 'idle' && !this.isPriceRefreshing(product) && !this.hasCardError(product);
  }

  /** Choose and pay / Finalise and pay: saves the chosen product and moves on to the pay page. The ITK modal is no longer in between. */
  onChooseClick(product: any, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (!this.canChoose(product) || this.choosingProductId !== null) {
      return;
    }
    this.selectedProduct = product;
    this.onContinue();
  }

  refreshExcessesSidesheet(productId: string, clearLoading: () => void): void {
    if (!productId) {
      clearLoading();
      return;
    }

    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails?.session_id);
    parameters.set('product_id', productId);
    parameters.set('frequency_id', this.frequencyId.toString());

    this.questionService.runCommandNew('getExcesses', parameters).subscribe({
      next: (excesses: any[]) => {
        this.excessesData = excesses;
        clearLoading();
      },
      error: () => {
        clearLoading();
      }
    });
  }

  setSelectedTier(tier: any): void {
    this.selectedTier = tier;
    // Passing the current selection keeps it on screen when the user switches back to
    // its tier; in any other tier it is simply not found and the window starts at 0.
    const slideIndex = this.buildProductsForTier(this.selectedProduct?.product_id);
    this.renderSlider(slideIndex);
  }

  isProductSelected(product: any): boolean {
    return this.selectedProducts.some(p => p.product_id === product.product_id);
  }

  hasSelectionChanged(): boolean {
    if (this.selectedProducts.length !== this.originalSelectedProducts.length) {
      return true;
    }
    return !this.selectedProducts.every(p =>
      this.originalSelectedProducts.some(op => op.product_id === p.product_id)
    );
  }

  setProduct(product: any): void {
    const index = this.selectedProducts.findIndex(p => p.product_id === product.product_id);
    if (index > -1) {
      // Product is already selected, remove it
      this.selectedProducts = this.selectedProducts.filter(p => p.product_id !== product.product_id);
    } else {
      // Product is not selected, add it
      this.selectedProducts = [...this.selectedProducts, product];
    }
    this.numPlans = this.selectedProducts.length;
    this.filterTouched = true;
    console.log(this.selectedProducts);
    this.rebuildSlider();
    this.filterTouched = true;
  }

  get maxFeatureItems(): number {
    return Math.max(
      1,
      ...(this.selectedProducts ?? []).map(product => product?.features?.length ?? 0)
    );
  }

  get maxBenefitItems(): number {
    return Math.max(
      1,
      ...(this.selectedProducts ?? []).map(product => product?.benefits?.length ?? 0)
    );
  }

  /** True when any visible card shows the "Including R… in added benefits" line, so the others reserve its height. */
  get anyAddonsPremium(): boolean {
    return (this.selectedProducts ?? []).some(product => !!product?.addons_premium);
  }

  get maxNotIncludedItems(): number {
    return Math.max(
      1,
      ...(this.selectedProducts ?? []).map(product => product?.not_included?.length ?? 0)
    );
  }

  /** A VAP or feature without an icon file falls back to the generic one, once. */
  onIconError(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img && !img.dataset['fallback']) {
      img.dataset['fallback'] = '1';
      img.src = 'assets/icn/24px-generic.svg';
    }
  }

  private destroySlider(): void {
    this.isSliderReady = false;
    const $chooseSlider = $('#choose-slider');
    if ($chooseSlider.length && $chooseSlider.hasClass('slick-initialized')) {
      $chooseSlider.slick('unslick');
    }
  }

  rebuildSlider(): void {
    this.filterTouched = false;
    this.renderSlider();
  }

 

  getItems(class_id: number): any {
    return this.summaryCollations.filter((item: { class_id: number }) => item.class_id === class_id);
  }

  editItem(collation: QuestionFlowCollation): void {
    //console.log(collation)
    this.showEditModal.emit({
      collations: this.collations,
      collation,
      product: this.product,
      person: this.summary.person,
      path: '3'
    });

    let allQuestions = this.QuestionQuery.getAllQuestions();
    const main_session = {
      session: this.sessionDetails,
      question: this.question,
      questions: allQuestions,
      active_class_id: collation.class_id,
      current_page: 'summary',
    };
    
    this.storageService.setJson('main_session', main_session, 'flow');
  }
  checkAddAnother(): boolean {
    try {
      if (this.parameter[1]?.value === 'add_another') {
        return true;
      }
      else {
        return false;
      }
    }
    catch {
      return false;
    }
  }
  gotToNext(): void {
    var a = '';
    try { a = this.parameter[1]?.value } catch (e) { };
    this.question.answer = a;
    this.submitResponse.next(undefined);
  }
  getRecommendation(item: any, class_level: boolean = false): any {
   
    let result: any = [];
     if (class_level) {
        result = this.recommendation.filter(i => i.class_id === item?.class_id && !i.item_id);
     }
     else {
      result = this.recommendation.filter(i => i.class_id === item?.class_id && i.item_id === item.session_item_id);
     }
    return result;
  }
  popUpRecommendation(recommend: any): void {
     this.selectedRecommendation = recommend;
     this.componentsService.setDiscountFlow(this.selectedRecommendation);
     $('#modal-discount-flow').modal('show')
  }
  startFlow(): void {
    console.log(this.selectedRecommendation);

  }

  goBack(): void {
    this.navigateBack.emit();
  }
  groupByClassName(items: any[]): { class_name: string; items: any[] }[] {
    const grouped = items.reduce((acc, item) => {
      const key = item.class_name || 'Other';
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {} as Record<string, any[]>);

    return Object.keys(grouped).map(class_name => ({
      class_name,
      items: grouped[class_name]
    }));
  }

  getQuoteITKs(product: any): void {
    this.selectedProduct = product;
    //this.questionService.spinner(true);
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails?.session_id);
    parameters.set('product_id', product.product_id);
    parameters.set('frequency_id', this.frequencyId.toString());
    this.questionService.runCommandNew('getQuoteITKs', parameters).subscribe({
      next: (itks: any[]) => {
        
        this.quoteITKs.sub_limits = itks.filter(itk => itk.entry_type === 'sublimit');
        this.quoteITKs.cover = itks.filter(itk => itk.entry_type === 'cover');
        this.quoteITKs.excess = this.groupByClassName(itks.filter(itk => itk.entry_type === 'excess'));
        
        this.questionService.spinner(false);
      },
      error: () => {
        this.questionService.spinner(false);
      }
    });
  }

  /**
   * Opens the policy wording page for one card, as quote-pick-cover did. The wording is about 1 MB a product,
   * so it is fetched here rather than carried in the page payload; the wording page reads it from the router state.
   */
  viewPolicyWording(product: any): void {
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails?.session_id);
    parameters.set('category_id', String(this.sessionDetails?.category_id));
    parameters.set('product_group_id', String(this.sessionDetails?.group_id));
    parameters.set('product_id', String(product?.product_id));
    parameters.set('frequency_id', String(this.frequencyId));
    this.questionService.spinner(true);
    this.questionService.runCommandNew('getQuoteWording', parameters).subscribe({
      next: (res: any[]) => {
        this.questionService.spinner(false);
        let wording: any = null;
        try {
          wording = JSON.parse(res?.[0]?.policy_wording ?? 'null');
        } catch {
          wording = null;
        }
        if (!wording?.details?.length) {
          Alert('No wording found for this product.');
          return;
        }
        this.storageService.set('previous-document-page', this.router.url, 'flow');
        this.router.navigate([RouterLinks.PolicyWording], {state: {wording, product}});
      },
      error: () => {
        this.questionService.spinner(false);
      }
    });
  }

  viewQuoteSchedule(product: any): void {
    console.log(product);
    window.open(`${RouterLinks.PolicyQuoteSchedule}?quote_id=${this.quote?.quote_id}&product_id=${product?.product_id}&print=false&pdf=false&source=quote-page`);
    //this.router.navigateByUrl(`${RouterLinks.PolicyQuoteSchedule}?quote_id=${product?.policy_id}&print=false&pdf=true`);
  }

  /** Found a better deal? card: opens the user's mail client with a pre-filled message to help. */
  emailUs(): void {
    const email = 'help@everything.insure';
    const subject = 'Help me on Everything.Insure';
    const body = 'Please could you contact me to help me with my insurance needs on Everything.Insure';
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  onContinue(): void {
    if (!this.canChoose(this.selectedProduct)) {
      return;
    }
    if (!this.selectedProduct?.product_id) {
      console.error('onContinue: no product selected', { products: this.products });
      return;
    }
    const parameters = new Map<string, string>();
    parameters.set('product_id', this.selectedProduct.product_id.toString());
    parameters.set('session_id', this.sessionDetails.session_id);
    parameters.set('product_group_id', this.sessionDetails.group_id.toString());
    // pending state on the chosen card's button until the page moves on (about 2s: save, then the pay page loads)
    this.choosingProductId = this.selectedProduct.product_id;
    // failsafe so a flow that never advances cannot leave the button spinning
    setTimeout(() => { this.choosingProductId = null; }, 20000);
    this.questionService.runCommandNew(`updateProductSelected`, parameters).subscribe({
      next: res => {
        console.log(res);
        this.chosenProductId = this.selectedProduct.product_id;
        this.question.answer = 'go to quote';
        this.storageService.setJson('selectedProduct', this.selectedProduct, 'flow');
        this.questionAnswer.emit(this.question);
        this.submitResponse.next(undefined);
      },
      error: () => {
        this.choosingProductId = null;
      }
    });
  }

  getOverallRating(insurerRating: any[]): number {
    if (!insurerRating?.[0]?.overall_rating) return 0;
    const stars = insurerRating[0].overall_rating.split('|');
    return stars.reduce((sum: number, val: string) => {
      const percent = parseInt(val, 10) || 0;
      return sum + (percent / 100);
    }, 0);
  }
 viewPricingBreakdown(product: any): void {
    if (!product?.price_breakdown_document_id) {
      return;
    }
    this.storageService.set('previous-document-page', this.router.url, 'flow');
    this.router.navigate(['/doc-document'], {
      state: {
        doc: { document_id: product.price_breakdown_document_id, document_name: 'Price Breakdown' },
        print: false,
        pdf: false,
        session_id: this.sessionDetails?.session_id,
        referrer_id: '1',
        product
      }
    });
  }
  ngOnDestroy(): void {
    this.summaryDataSubscription?.unsubscribe();
    document.querySelector('body')?.classList.remove('page--questions');
    document.querySelector('body')?.classList.remove('page--questions-no-tray');
    document.querySelector('body')?.classList.remove('page--questions-top-aligned');
  }
}
